import { ref } from 'vue';

export const DEFAULT_TITLE = document.title;

// this changes based on route - if there are different apps on different routes. See /router/index.js
export const pageTitle = ref(DEFAULT_TITLE);

